<template>
  <div class="container">
    <!-- 头部部分 -->
    <div class="breadCrumpWrap"  v-if="searchUserName">
        <span class="backBtn" @click="back"> <i class="el-icon-arrow-left"></i> 返回</span>
        <div class="itemBox">
            <span>
                <span class="name">{{searchUserName}}</span>
                <span class="lineIcon">&gt;</span>
                <span class="name">清算列表</span>
            </span>
        </div>
    </div>
    <div class="breadCrumpWrap"  v-if="!searchUserName">
        <div class="itemBox">
            <span>
                <span class="name">清算列表</span>
            </span>
        </div>
    </div>
    <div class="pageTitleBox" v-if="searchUserName">
      <div class="pageTitleName">{{searchUserName}}</div>
      <div class="rightBtnBox">
        <el-button type="primary" size="mini" @click="toPageLock">锁仓订单</el-button>
        <el-button type="primary" size="mini" @click="toPageOrder">下单订单</el-button>
        <!-- <el-button type="primary" size="mini" @click="toPageClear">清算订单</el-button> -->
      </div>
    </div>
    <div class="searchBox">
      <div class="left">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="ID/商品名称/款号" v-model="formObj.fuzzyQuery" clearable></el-input>
          </el-form-item>
          <el-form-item  v-if="!searchUserName">
            <el-select  @change="changeUserOption"
                v-model="searchUser"
                filterable
                placeholder="选择销售商/供应商"
                >
                <el-option
                  v-for="item in options_user"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>

          </el-form-item>

          <el-form-item>
            <el-select v-model="searchBrand" filterable placeholder="请选择品牌">
                <el-option
                  v-for="item in options_brand"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="right">
                <el-button>下载列表</el-button>
      </div>-->
    </div>
    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData" size="small">
        <el-table-column align="center" label="序号" type="index" width="50" :index="indexMethod" >
        </el-table-column>
        <el-table-column prop="order_number" label="清算订单号" width="80">
        </el-table-column>
        <el-table-column prop="mallItemFileUrl" label="图片" width="80">
          <template slot-scope="scope">
            <el-image style="width: 64px; height: 64px" :src="scope.row.mallItemFileUrl" fit="cover" :preview-src-list="[scope.row.mallItemFileUrl]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="商品名称" width="100">
        </el-table-column>
        <el-table-column prop="brand" label="品牌" width="70">
        </el-table-column>
        <el-table-column prop="styleNumber" label="款号" width="80">
        </el-table-column>
        <el-table-column prop="dealerName" label="销售商" width="80"></el-table-column>
        <el-table-column prop="supplierName" label="供应商" width="70">
        </el-table-column>

        <el-table-column prop="orderPurchaseQuantity" label="总下单数" width="60">
        </el-table-column>
        <el-table-column prop="sumEstablishQuantity" label="已核销数" width="60">
        </el-table-column>
        <el-table-column prop="notEstablishNumber" label="未核销数" width="60">
        </el-table-column>
        <el-table-column prop="returnQuantity" label="退货数" width="60">
        </el-table-column>
        <el-table-column prop="needPay" label="总需支付额(元)" width="80"></el-table-column>
        <el-table-column prop="sumPay" label="已确认累计支付额(元)" width="80">
        </el-table-column>
        <el-table-column prop="amountToBeConfirmed" label="待确认金额(元)" width="80">
        </el-table-column>
        <el-table-column prop="debtMoney" label="欠款(元)" width="80">

        </el-table-column>
        <el-table-column prop="requestAmount" label="总共可申请额度(元)" width="80"></el-table-column>
        <el-table-column prop="toBeReviewed" label="待审核申请额(元)" width="80"></el-table-column>


        <el-table-column prop="order_submit_time" label="清算时间" width="90">
        </el-table-column>
        <el-table-column prop="itemState" label="订单状态" width="120" fixed="right">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.order_state == 6" type="success" size="medium">清算完成</el-tag>
            <el-tag v-else type="warning" size="medium">
              {{liquidationState[scope.row.order_state ]}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="140" fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"  :underline="false" @click="toClearDetail(scope.row)"  size="small"  v-show="function_clearView">查看</el-link>
            <div class="inlineBlock" v-if="'24'.search(scope.row.order_state)>-1">
              <el-divider direction="vertical"></el-divider>
              <el-link type="primary" :underline="false" @click="toClearDetail(scope.row)" size="small"  v-show="function_clearControl">填写退货</el-link>
            </div>
            <div class="inlineBlock" v-if=" ('3'.search(scope.row.order_state)>-1 ) &&scope.row.debtMoney>0">
              <el-divider direction="vertical"></el-divider>
              <el-link type="primary" :underline="false" @click="toClearDetail(scope.row)"  size="small"  v-show="function_clearControl">去付款</el-link>
            </div>
            <!-- <el-button class="cg-icon-btn" @click="toGoodsEdit(scope.row)" type="text" size="small">确认退货</el-button> -->
            <div class="inlineBlock" v-if="scope.row.toBeReviewed>0">
              <el-divider direction="vertical"></el-divider>
              <el-link type="danger"  :underline="false" @click="toClearDetail(scope.row)"    v-show="function_clearControl">打款申请审核</el-link>
            </div>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="searchObj.page"
        :page-size.sync="searchObj.num"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import {    json,    wordData ,utils  } from '@/common/common.js'
import { ajaxPost, api } from "@/common/request.js"
export default {
  name: "listOrder",
  data() {
    return {
      isLoading: false,
      formObj: {
        fuzzyQuery: ""
      },
      searchBrand:'',
      searchUserName:'',
      searchUser:'',
      options_user:[],
      options_brand:[],
      searchObj: {
        page: 1,
        num: 10
      },
      //表格
      tableData: [],
      //分页
      total: 0,
      liquidationState:{
        1: '取消/关闭',
        2: '请填写退货',
        3: '清算付款阶段',
        4: '退货数被拒绝',
        5: '退货数待审核',
        6: '清算完成'
      },
    };
  },
  computed: {
    IMG_PREV() {
      return api.imgPrev;
    },
    function_lockView() {
      return utils.getCurrentFunction().indexOf("lockView")>-1
    },
    function_lockControl() {
      return utils.getCurrentFunction().indexOf("lockControl")>-1
    },
    function_orderView() {
      return utils.getCurrentFunction().indexOf("orderView")>-1
    },
    function_orderControl() {
      return utils.getCurrentFunction().indexOf("orderControl")>-1
    },
    function_clearView() {
      return utils.getCurrentFunction().indexOf("clearView")>-1
    },
    function_clearControl() {
      return utils.getCurrentFunction().indexOf("clearControl")>-1
    },
  },
  watch: {
    $route: {
      handler: function(route) {
        this.searchObj.num = Number(this.$route.query.size)
          ? Number(this.$route.query.size)
          : 10;
        this.searchObj.page = Number(this.$route.query.page)
          ? Number(this.$route.query.page)
          : 1;
        this.formObj.fuzzyQuery = this.$route.query.search || "";
        this.searchBrand=this.$route.query.searchBrand || "";
        this.searchUser=this.$route.query.searchUser || "";
        this.searchUserName=this.$route.query.searchUserName || "";
        // this.getCurrentOptionByOneUserId(this.searchUser)
        this.getTableLists();
      },
      immediate: true
    }
  },
  components: {},
  methods: {
    toPageLock(){
      this.$router.push("/order/lockList?" +"&searchUser=" +this.searchUser+"&searchUserName="+this.searchUserName)
    },
    toPageOrder(){
      this.$router.push("/order/orderList?" +"&searchUser=" +this.searchUser+"&searchUserName="+this.searchUserName)
    },
    toPageClear(){
      this.$router.push("/order/clearList?" +"&searchUser=" +this.searchUser+"&searchUserName="+this.searchUserName)
    },
    getBrandOption(){
      let _this=this
      let arg={
        userId:this.searchUser
      }
      _this.options_brand =[{text:"所有品牌",value:""}]
      ajaxPost('/commodity/brandListByUser', arg).then(function(res){
        console.log(res)
        if(res.errorCode==200){
          res.data.map(function(item,index){
            let buffer={
              text:item.item_display_name,
              value:item.item_display_name
            }
            _this.options_brand.push(buffer)
          })

        }
      })
    },
    changeUserOption(){//获取品牌-选项
      let _this=this
      this.searchBrand=''
      this.getBrandOption()
    },
    getCurrentOptionByOneUserId(param){
      let _this=this
      if(!param){
        return false
      }
      let userId=param
      let arg={
        userId:userId
      }
      // _this.options_user=[]
      // // 查询基本信息
      // ajaxPost('/admin/getDwUserInfo', arg).then(function(res) {
      //   if(res.errorCode==200){
      //     let resObj=res.data[0]||{}
      //     let name=resObj.user_organization_name||resObj.user_individual_name
      //     let buffer={text:name,value:userId}
      //     _this.options_user.push(buffer)
      //   }
      // }, function(res) {})
      // 查询品牌
      let brandArr=[{text:"所有品牌",value:""}]
      ajaxPost('/commodity/brandListByUser', arg).then(function(res){
        if(res.errorCode==200){
          res.data.map(function(item,index){
            let buffer={
              text:item.item_display_name,
              value:item.item_display_name
            }
            brandArr.push(buffer)
          })
        }else{
          brandArr=[{text:"所有品牌",value:""}]
        }
        _this.options_brand=brandArr
      })

    },
    getOptionUser(query) {//获取选项-用户
      let _this = this
      let newQuery=this.trimAll(query)
      console.log(query,newQuery)
      let arg={
        num: 10000,
        page: 1,
        fuzzyQuery:newQuery
      }
      this.loadingOptionUser = true
      _this.options_user =[]
      ajaxPost('/admin/userList', arg).then(function(res) {
        console.log(res)
        _this.loadingOptionUser = false
        let initOption={text:"全部用户",value:""}
        _this.options_user.push(initOption)
        if (res.data && res.data.userList) {

          res.data.userList.forEach(function(item, index) {
            let buffer={
              // text:( item.user_organization_name||item.user_individual_name)+'-'+item.user_id,
              text:item.user_organization_name||item.user_individual_name,
              value:item.user_id,
            }
            _this.options_user.push(buffer)

          })

        }
        console.log(1111111111)
      }, function(res) {

        _this.options_user =[{text:"全部用户",value:""}]
        _this.loadingOptionUser = false
        console.log(2222222222222222222222222222)
      })
    },
    indexMethod(index) {
      return (
        this.total - this.searchObj.num * (this.searchObj.page - 1) - index
      );
    },
    toClearDetail(row) {
      this.$router.push('/order/clearDetail?orderId=' + row.order_id)
    },
    back() {
      this.$router.back();
    },
    fuzzySearchClick() {
      this.searchObj.page = 1;
      this.updateRouter();
    },
    updateRouter() {
      this.$router
        .push(
          "/order/clearList?search=" +
            this.formObj.fuzzyQuery +
            "&page=" +
            this.searchObj.page +
            "&size=" +
            this.searchObj.num+
            "&searchBrand=" +
            this.searchBrand+
            "&searchUser=" +
            this.searchUser+
            "&searchUserName="+
            this.searchUserName
        )
    },
    getTableLists() {
      let _this = this
      this.isLoading = true
      ajaxPost('/dwOrder/getLiquidateList',
        {
          supplierUserId: "",
          dealerUserId: "",
          page: this.searchObj.page,
          num: this.searchObj.num,
          fuzzyQuery: this.formObj.fuzzyQuery,
          brand:this.searchBrand,
          queryString:this.searchUser
        }
      ).then(function(res) {
        _this.tableData = []
        _this.isLoading = false
        console.log('getLiquidateList', res)
        if (res.errorCode == 200) {
          _this.tableData = res.data.orderList.map(item => {
            let mallItemFileUrl
            if (item.mallItemFileUrl) {
              mallItemFileUrl = _this.IMG_PREV  + item.mallItemFileUrl
            } else if (item.orderPurchaseList && item.orderPurchaseList[0] && item.orderPurchaseList[0].productMainImageFile) {
              mallItemFileUrl = _this.IMG_PREV  + item.orderPurchaseList[0].productMainImageFile
            }

            let debtMoney = utils.computeSub(item.needPay,item.sumPay)
            let notEstablishNumber = utils.computeSub(item.orderPurchaseQuantity, item.sumEstablishQuantity)
            return {
              ...item,
              debtMoney,
              notEstablishNumber,
              mallItemFileUrl
            }
          })
          _this.total = parseInt(res.data.totalCount)
        } else {
          _this.$message.error(res.errorMsg || '获取列表数据失败')
        }
      }, function(res) {
        _this.isLoading = false
      })
    },
    handleSizeChange(size) {
      //分页：每页n条
      this.searchObj.num = size;
      this.searchObj.page = 1;
      this.updateRouter();
    },
    handleCurrentChange(page) {
      //分页：改变第n页
      this.searchObj.page = page;
      this.updateRouter();
    }
  },
  created() {},
  mounted() {
    this.getOptionUser()
    this.getBrandOption()
  }
};
</script>

<style scoped lang="scss">
.searchBox {
  padding: 0.25rem 0.25rem 0;
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
.searchBox:after {
  content: "";
  display: block;
  clear: both;
}
.tableBox {
  padding: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/list-clear.vue